import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  private appName = 'Saltus Partners';

  constructor(
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.route.firstChild;
        while (child?.firstChild) child = child.firstChild;
        return child?.snapshot.data['title'];
      })
    ).subscribe(title => {
      this.titleService.setTitle(title ? `${title} | ${this.appName}` : this.appName);
    });
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
